module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/123.8e62fae2.png";